
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twentyfourintosevan() {



    const cardData =
    {
        keyword: '24x7 Cab Service Pune',
        heading: 'Platinum24 Cabs: 24x7 Cab Service Pune',
        headingDescription: ' Platinum24 Cabs provides reliable 24x7 Cab Service in Pune, ensuring safe and convenient travel at any time of the day or night. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is available round the clock for local city rides, airport transfers, corporate trips, and outstation journeys. With professional chauffeurs, quick response times, and transparent fares, we make sure your travel is stress-free and dependable. Whether it’s an early morning airport drop, a late-night pickup, or an emergency outstation ride, Platinum24 Cabs guarantees comfort, punctuality, and 24/7 availability across Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



  "services": [
    {
      "name": "24x7 Taxi Service Pune",
      "description": "Experience the convenience of our 24x7 Taxi Service in Pune, offering round-the-clock availability to meet all your transportation needs. Whether it’s early morning, late night, or anytime in between, our taxis are ready to serve you promptly with professional drivers and comfortable vehicles."
    },
    {
      "name": "Pune Round the Clock Taxi",
      "description": "Our Pune Round the Clock Taxi service ensures you never have to worry about transport, no matter the hour. From daily commutes to urgent travel needs, enjoy seamless service anytime throughout the day or night."
    },
    {
      "name": "All Day Cab Service Pune",
      "description": "With our All Day Cab Service in Pune, travel freely without time constraints. Ideal for business, leisure, or emergencies, our cabs are available all day long, providing reliable and affordable rides."
    },
    {
      "name": "24 Hour Cab Booking Pune",
      "description": "Book your taxi anytime with our 24 Hour Cab Booking service in Pune. Our easy-to-use online platform and phone booking ensure hassle-free reservations at any hour."
    },
    {
      "name": "Pune Night and Day Taxi Service",
      "description": "Enjoy safe and reliable Pune Night and Day Taxi Service for all your transportation requirements. Our well-maintained fleet and trained drivers guarantee comfortable rides around the clock."
    },
    {
      "name": "24x7 Taxi Hire Pune",
      "description": "Avail our 24x7 Taxi Hire service in Pune for flexible and affordable transport options. Whether you need a short local trip or a long-distance journey, our taxis are at your service 24 hours a day."
    },
    {
      "name": "Pune 24x7 Cab with Driver",
      "description": "Travel stress-free with our Pune 24x7 Cab with Driver service. Our professional chauffeurs are available round-the-clock to ensure timely pickups and safe journeys."
    },
    {
      "name": "Emergency Taxi Service Pune",
      "description": "Need a taxi in a hurry? Our Emergency Taxi Service in Pune operates 24x7 to provide immediate transport solutions during emergencies or urgent situations."
    },
    {
      "name": "Pune 24x7 Airport Taxi",
      "description": "Catch your flights on time with our Pune 24x7 Airport Taxi service. Available day and night, we provide reliable airport pickups and drop-offs at competitive rates."
    },
    {
      "name": "24x7 Local Cab Service Pune",
      "description": "For all your local travel needs, our 24x7 Local Cab Service in Pune offers convenient and affordable rides any time of the day or night."
    },
    {
      "name": "Pune 24x7 Outstation Taxi",
      "description": "Travel beyond Pune anytime with our 24x7 Outstation Taxi service. Whether it’s business or leisure, our outstation taxis are ready to take you wherever you need to go."
    },
    {
      "name": "24x7 Cab Service Near Me Pune",
      "description": "Find reliable 24x7 Cab Service Near Me in Pune with ease. Our extensive network ensures quick dispatch and prompt service wherever you are in the city."
    },
    {
      "name": "Pune 24x7 Cab Booking Online",
      "description": "Book your taxi instantly with our Pune 24x7 Cab Booking Online facility. Our user-friendly platform allows you to reserve cabs anytime, anywhere with just a few clicks."
    },
    {
      "name": "24x7 Corporate Taxi Pune",
      "description": "Our 24x7 Corporate Taxi service in Pune caters specifically to businesses requiring flexible, timely, and professional transportation solutions at any hour."
    },
    {
      "name": "Pune 24x7 Cab Service Deals",
      "description": "Take advantage of special Pune 24x7 Cab Service Deals offering affordable rates and exclusive discounts on round-the-clock taxi services."
    }
  ],
  "tableData": [
    ["24x7 Taxi Service Pune", "Pune Round the Clock Taxi"],
    ["All Day Cab Service Pune", "24 Hour Cab Booking Pune"],
    ["Pune Night and Day Taxi Service", "24x7 Taxi Hire Pune"],
    ["Pune 24x7 Cab with Driver", "Emergency Taxi Service Pune"],
    ["Pune 24x7 Airport Taxi", "24x7 Local Cab Service Pune"],
    ["Pune 24x7 Outstation Taxi", "24x7 Cab Service Near Me Pune"],
    ["Pune 24x7 Cab Booking Online", "24x7 Corporate Taxi Pune"],
    ["Pune 24x7 Cab Service Deals", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Reliable 24x7 Cab Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers round-the-clock cab services in Pune, ensuring you can travel anytime, day or night."
    },
    {
      "WhyChooseheading": "Instant Cab Booking at Any Hour",
      "WhyChoosedescription": "Our drivers are always ready to pick you up quickly, no matter the time or location in Pune."
    },
    {
      "WhyChooseheading": "Safe and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for your safety and comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers Available 24/7",
      "WhyChoosedescription": "Our professional and background-checked drivers ensure a safe and smooth ride at any hour."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront, fair pricing including fuel, tolls, and driver allowances at all times."
    },
    {
      "WhyChooseheading": "Easy Online Booking and Real-Time Tracking",
      "WhyChoosedescription": "Book your cab anytime via our website or app and track your ride live for peace of mind."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers for solo or group travel."
    },
    {
      "WhyChooseheading": "Dedicated Customer Support 24/7",
      "WhyChoosedescription": "Our customer care team is always available to assist with bookings, cancellations, or changes."
    }
  ]












































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer 24x7 cab service in Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable 24x7 cab services in Pune, ensuring you can book a ride anytime, day or night.',
    },
    {
        question: 'How can I book a 24x7 cab in Pune with Platinum24 Cabs?',
        answer: 'You can book a 24x7 cab through our website, mobile app, or by calling our customer support at any time.',
    },
    {
        question: 'Are the drivers available round the clock for cab services in Pune?',
        answer: 'Yes, our professional drivers are available 24x7 to provide you with timely and safe transportation services.',
    },
    {
        question: 'What types of vehicles are available in the 24x7 cab service fleet?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, tempo travellers, and luxury cars to cater to your needs any time of the day.',
    },
    {
        question: 'Is the 24x7 cab service available for airport transfers and outstation travel?',
        answer: 'Yes, our 24x7 service covers local travel, airport transfers, and outstation trips from Pune.',
    },
    {
        question: 'Are there any additional charges for booking a cab late at night or early morning?',
        answer: 'Our pricing is transparent; any additional charges for late-night bookings, if applicable, will be clearly communicated upfront.',
    },
    {
        question: 'How quickly can a 24x7 cab be arranged in Pune?',
        answer: 'We strive to arrange a cab as quickly as possible, often within minutes depending on your location and availability.',
    },
    {
        question: 'Are the cabs sanitized and safe during the 24x7 service?',
        answer: 'Yes, all our vehicles are regularly sanitized, and drivers follow strict safety protocols to ensure your safety at all times.',
    },
    {
        question: 'Can I schedule a cab in advance for late night or early morning in Pune?',
        answer: 'Yes, you can pre-book your cab for any time of the day or night to ensure availability.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate 24x7 cab services in Pune?',
        answer: 'Yes, we offer specialized 24x7 corporate cab services with priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Amit Shinde',
        feedback: 'Platinum24’s 24x7 cab service in Pune is dependable. I booked a ride late at night, and the driver arrived promptly.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Rao',
        feedback: 'Excellent 24x7 cab service! Always available when I need a ride, even during odd hours.',
        rating: 5,
    },
];


















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const cab247Schema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable 24x7 Cab Service in Pune offering round the clock taxi availability, emergency cab booking, airport transfers, local and outstation taxi services.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "24x7 Taxi Service Pune",
    "Pune Round the Clock Taxi",
    "All Day Cab Service Pune",
    "24 Hour Cab Booking Pune",
    "Pune Night and Day Taxi Service",
    "24x7 Taxi Hire Pune",
    "Pune 24x7 Cab with Driver",
    "Emergency Taxi Service Pune",
    "Pune 24x7 Airport Taxi",
    "24x7 Local Cab Service Pune",
    "Pune 24x7 Outstation Taxi",
    "24x7 Cab Service Near Me Pune",
    "Pune 24x7 Cab Booking Online",
    "24x7 Corporate Taxi Pune",
    "Pune 24x7 Cab Service Deals"
  ]
};





    return (
        <div>

<Helmet>
  <title>24x7 Cab Service Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable 24x7 Cab Service in Pune offering round the clock taxi availability, emergency cab booking, airport transfers, local and outstation taxi services."
  />
  <meta
    name="keywords"
    content="24x7 Taxi Service Pune, Pune Round the Clock Taxi, All Day Cab Service Pune, 24 Hour Cab Booking Pune, Pune Night and Day Taxi Service, 24x7 Taxi Hire Pune, Pune 24x7 Cab with Driver, Emergency Taxi Service Pune, Pune 24x7 Airport Taxi, 24x7 Local Cab Service Pune, Pune 24x7 Outstation Taxi, 24x7 Cab Service Near Me Pune, Pune 24x7 Cab Booking Online, 24x7 Corporate Taxi Pune, Pune 24x7 Cab Service Deals"
  />
  <script type="application/ld+json">
    {JSON.stringify(cab247Schema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Twentyfourintosevan;